define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"./Attribute",
	"./Container"
], function(declare, _, Attribute, Container) {

	return declare(Container, {
		bSort: true,
		tagAction: "ActionStringSelection",

		_getAction: function() {
			// summary: restore editing for string containers
			return Attribute.prototype._getAction.call(this);
		},

		_getRenderAction: function(/*Context*/ctx, /*Heading*/h) {
			// summary: prevent action if there is no relationship or action
			return (h.m_relationship || h.m_action) ? this.inherited(arguments) : null;
		},

		_getSortValues: function(/*Context*/ctx, /*Heading*/h, /*Any*/value, /*String[]*/textValues) {
			// summary: sort by given text values
			return textValues;
		}
	});
});